<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="60%"
            top="2vh"
            custom-class="modalAddUser"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
            @closed="onHidden"
            :before-close="onHidden">
            <template slot="title">
                <h1 style="margin:unset;text-align:left;">เพิ่มผู้ใช้งาน และร้านค้า</h1>
            </template>
            <el-row>
                <el-col class="text-md-left" :sm="24">
                    <el-steps :active="stepActive" finish-status="success">
                        <el-step title="สร้างผู้ใช้งาน"></el-step>
                        <el-step title="ข้อมูลผู้ใช้งาน"></el-step>
                        <el-step title="ข้อมูลร้านค้า"></el-step>
                    </el-steps>
                    <div class="dv_addUser">
                        <template v-if="stepActive === 0">
                            <el-form
                                ref="formUserAddInfo"
                                :rules="rulesUserAddInfo"
                                label-position="left"
                                label-width="220px"
                                :model="formUserAddInfo">
                                <el-alert
                                    style="margin:10px 0px;"
                                    title="คำเตือน"
                                    :closable="false"
                                    type="warning"
                                    description="กรุณาตรวจเช็คความถูกต้องทุกครั้งที่ทำรายการ !"
                                    show-icon>
                                </el-alert>
                                <el-form-item label="อีเมล์สำหรับล๊อกอินใช้งาน" prop="email" class="labelForm">
                                    <el-input v-model="formUserAddInfo.email"></el-input>
                                </el-form-item>
                                <el-form-item label="รหัสผ่าน" prop="password" class="labelForm">
                                    <el-input v-model="formUserAddInfo.password"></el-input>
                                </el-form-item>
                                <el-form-item label="ชื่อ" prop="first_name" class="labelForm">
                                    <el-input v-model="formUserAddInfo.first_name"></el-input>
                                </el-form-item>
                                <el-form-item label="นามสกุล" prop="last_name" class="labelForm">
                                    <el-input v-model="formUserAddInfo.last_name"></el-input>
                                </el-form-item>
                                <el-form-item label="เบอร์โทรศัพท์" prop="phone_number" class="labelForm">
                                    <el-input v-model="formUserAddInfo.phone_number"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="addUserFirebase">สร้างผู้ใช้งาน</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                        <template v-if="stepActive === 1">
                            <el-form
                                style="margin-top:10px;"
                                ref="formUserInfo"
                                :rules="rulesUserInfo"
                                label-position="left"
                                label-width="220px"
                                :model="formUserInfo">
                                <el-form-item label="รหัสลูกค้า" prop="user_code" class="labelForm">
                                    <el-input v-model="formUserInfo.user_code"></el-input>
                                </el-form-item>
                                <el-form-item label="ที่อยู่เข้ารับสินค้า" prop="address">
                                    <el-input v-model="formUserInfo.address"></el-input>
                                </el-form-item>
                               <helper-province :info.sync="formUserInfo"
                                :provincearray="provinceArray"
                                :name="nameProvince"
                                :geo="geoHierarchyData" />
                                <el-form-item>
                                    <el-button type="primary" @click="saveUserInfo"><fa-icon name="save"></fa-icon>&nbsp;บันทึกข้อมูลผู้ใช้งาน</el-button>
                                </el-form-item>
                             </el-form>
                        </template>
                        <template v-if="stepActive === 2">
                            <el-form
                                style="margin-top:10px;"
                                ref="formShopInfo"
                                :rules="rulesFormShopInfo"
                                label-position="left"
                                label-width="220px"
                                :model="formShopInfo">
                                <el-form-item label="ชื่อร้าน" prop="name" class="labelForm">
                                    <el-input v-model="formShopInfo.name"></el-input>
                                </el-form-item>
                                <el-form-item label="ประเภทร้านค้า" prop="goods_type">
                                    <el-select v-model="formShopInfo.goods_type">
                                        <el-option v-for="(item, index) in shopGoodsTypeList"
                                            :key="index"
                                            :value="item.id"
                                            :label="item.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="เบอร์โทรร้าน" prop="phone_number" class="labelForm">
                                    <el-input v-model="formShopInfo.phone_number"></el-input>
                                </el-form-item>
                                <el-form-item label="อีเมล์" prop="email" class="labelForm">
                                    <el-input v-model="formShopInfo.email"></el-input>
                                </el-form-item>
                                <el-form-item label="LINE" prop="line" class="labelForm">
                                    <el-input v-model="formShopInfo.line"></el-input>
                                </el-form-item>
                                <el-form-item label="FACEBOOK" prop="facebook" class="labelForm">
                                    <el-input v-model="formShopInfo.facebook"></el-input>
                                </el-form-item>
                                <el-form-item label="INSTAGRAM" prop="instagram" class="labelForm">
                                    <el-input v-model="formShopInfo.instagram"></el-input>
                                </el-form-item>
                                <el-form-item label="ที่อยู่ร้าน" prop="address" class="labelForm">
                                    <el-input v-model="formShopInfo.address"></el-input>
                                </el-form-item>
                                <helper-province :info.sync="formShopInfo"
                                :provincearray="provinceArray"
                                :name="nameProvince"
                                :geo="geoHierarchyData" />
                                <el-form-item label="อัพโหลดสลิป" class="labelForm">
                                    <el-switch v-model="formShopInfo.active_upload_slip" class="labelForm"></el-switch>
                                </el-form-item>

                                <el-form-item>
                                    <el-button type="primary" @click="saveFormShopInfo"><fa-icon name="save"></fa-icon>&nbsp;บันทึกข้อมูลร้านค้า</el-button>
                                </el-form-item>
                            </el-form>
                        </template>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" type="danger" plain>ยกเลิก</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import helperProvince from '@/components/helper/BaseProvinceSelect'
const InitForm = {
    formAddUser: {
        email: '',
        password: 'q1w2e3r4',
        first_name: '',
        last_name: '',
        phone_number: ''
    },
    formUserInfo: {
        user_code: '',
        address: '',
        subDistrict: '',
        district: '',
        province: '',
        zipcode: ''
    },
    formShopInfo: {
        name: '',
        phone_number: '',
        goods_type: '',
        line: '',
        facebook: '',
        instagram: '',
        address: '',
        subDistrict: '',
        email: '',
        district: '',
        province: '',
        zipcode: '',
        active_upload_slip: false
    }
}

export default {
    name: 'ModalAddCustomer',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        }
    },
    components: {
        helperProvince
    },
    data () {
        let validatePhone = (rule, value, callback) => {
            if (value.length > 10) {
                return callback(new Error('กรุณาระบุเบอร์โทรศัพท์ไม่เกิน 10 ตัว'))
            }
            if (!value) {
                return callback(new Error('กรุณากรอกเบอร์โทรลูกค้า'))
            }
            if (!/^[0-9]+$/.test(value)) {
                callback(new Error('กรุณากรอกเฉพาะตัวเลข'))
            } else {
                callback()
            }
        }
        return {
            stepActive: 0,
            dialogVisible: false,
            formUserAddInfo: InitForm.formAddUser,
            rulesUserAddInfo: {
                email: [
                    { required: true, message: 'กรุณากรอกอีเมล์ลูกค้า', trigger: 'blur' },
                    { type: 'email', message: 'กรุณากรอกรูปแบบอีเมล์ให้ถูกต้อง', trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: 'กรุณากรอกรหัสผ่านลูกค้า', trigger: 'blur' }
                ],
                first_name: [
                    { required: true, message: 'กรุณากรอกชื่อลูกค้า', trigger: 'blur' }
                ],
                last_name: [
                    { required: true, message: 'กรุณากรอกนามสกุลลูกค้า', trigger: 'blur' }
                ],
                phone_number: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ]
            },
            customerID: 'lQKjmlY2y0Zu9x2U3ceKg2gCt5g2',
            formUserInfo: InitForm.formUserInfo,
            rulesUserInfo: {
                user_code: [
                    { required: true, message: 'กรุณากรอกรหัสลูกค้า', trigger: 'blur' }],
                subDistrict: [
                    { required: true, message: 'กรุณากรอกตำบล', trigger: ['blur', 'change'] }],
                district: [
                    { required: true, message: 'กรุณากรอกอำเภอ', trigger: ['blur', 'change'] }],
                province: [
                    { required: true, message: 'กรุณากรอกจังหวัด', trigger: ['blur', 'change'] }],
                zipcode: [
                    { required: true, message: 'กรุณากรอกรหัสไปรษณีย์ร้านค้า', trigger: 'blur' }]
            },
            formShopInfo: InitForm.formShopInfo,
            rulesFormShopInfo: {
                name: [
                    { required: true, message: 'กรุณากรอกรหัสลูกค้า', trigger: 'blur' }],
                goods_type: [
                    { required: true, message: 'กรุณาระบุประเภทร้านค้า', trigger: 'blur' }],
                email: [
                    { required: true, message: 'กรุณากรอกอีเมล์ลูกค้า', trigger: 'blur' },
                    { type: 'email', message: 'กรุณากรอกรูปแบบอีเมล์ให้ถูกต้อง', trigger: ['blur', 'change'] }],
                phone_number: [
                    { required: true, validator: validatePhone, trigger: 'blur' }],
                subDistrict: [
                    { required: true, message: 'กรุณากรอกตำบล', trigger: ['blur', 'change'] }],
                district: [
                    { required: true, message: 'กรุณากรอกอำเภอ', trigger: ['blur', 'change'] }],
                province: [
                    { required: true, message: 'กรุณากรอกจังหวัด', trigger: ['blur', 'change'] }],
                zipcode: [
                    { required: true, message: 'กรุณากรอกรหัสไปรษณีย์ร้านค้า', trigger: 'blur' }]
            },
            rulesShopInfo: {},
            geoHierarchyData: {},
            provinceArray: [],
            nameProvince: {
                provi: 'province',
                distr: 'district',
                subDist: 'subDistrict'
            }
        }
    },
    async mounted () {
        let geoJsonData = require('@/assets/geo.json')
        geoJsonData.forEach(e => {
            if (!(e['province'] in this.geoHierarchyData)) {
                this.geoHierarchyData[e['province']] = {}
            }
            if (!(e['amphoe'] in this.geoHierarchyData[e['province']])) {
                this.geoHierarchyData[e['province']][e['amphoe']] = {}
            }
            if (
                !(
                    e['district'] in
                    this.geoHierarchyData[e['province']][e['amphoe']]
                )
            ) {
                this.geoHierarchyData[e['province']][e['amphoe']][e['district']] = e['zipcode']
            }
        })
        for (let provice in this.geoHierarchyData) {
            this.provinceArray.push(provice)
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                this.dialogVisible = true
                // clear form
                this.stepActive = 0
            }
        }

    },
    methods: {
        // async querySearchShiperID (queryString, cb) {
        //     let param = {
        //         shipper_code: this.formUserInfo.shipper_code
        //     }
        //     let listShiperID = await fgApi.courier.searchScgAccount(param)
        //     console.log(listShiperID)
        //     cb(listShiperID.data)
        // },
        // handleSelectShiperID (item) {
        //     console.log(item)
        //     this.formUserInfo.shipper_code = item.shipperCode
        //     this.formUserInfo.scg_username = item.username
        //     this.formUserInfo.scg_password = item.password
        // },
        onHidden (done) {
            if (done !== undefined) {
                done()
            }

            this.stepActive = 0
            this.$emit('closeModal')
            this.$nextTick(() => { // ES6 arrow function
                this.formUserAddInfo = {
                    email: '',
                    password: 'q1w2e3r4',
                    first_name: '',
                    last_name: '',
                    phone_number: ''
                }
                this.formUserInfo = {
                    user_code: '',
                    address: '',
                    subDistrict: '',
                    district: '',
                    province: '',
                    zipcode: ''
                }

                this.formShopInfo = {
                    name: '',
                    phone_number: '',
                    goods_type: '',
                    line: '',
                    facebook: '',
                    instagram: '',
                    address: '',
                    email: '',
                    subDistrict: '',
                    district: '',
                    province: '',
                    zipcode: '',
                    active_upload_slip: false
                }
                // console.log(this.formUserAddInfo)

                if (this.stepActive === 0) {
                    this.$refs['formUserAddInfo'].resetFields()
                } else if (this.stepActive === 1) {
                    this.$refs['formUserAddInfo'].resetFields()
                    this.$refs['formUserInfo'].resetFields()
                } else if (this.stepActive === 2) {
                    this.$refs['formUserAddInfo'].resetFields()
                    this.$refs['formUserInfo'].resetFields()
                    this.$refs['formShopInfo'].resetFields()
                }
            })

            // this.$refs['formUserInfo'].resetFields()
            // this.popShowScgAcc = false
        },
        nextStep () {
            if (this.stepActive++ > 2) this.stepActive = 0
            if (this.stepActive === 1) {
                this.$nextTick(() => {
                    this.$refs['formUserInfo'].resetFields()
                })
            }
            if (this.stepActive === 2) {
                this.$nextTick(() => {
                    this.$refs['formShopInfo'].resetFields()
                })
            }
        },
        async addUserFirebase () {
            this.$refs['formUserAddInfo'].validate(async (valid) => {
                if (valid) {
                    let param = {
                        email: this.formUserAddInfo.email,
                        password: this.formUserAddInfo.password,
                        first_name: this.formUserAddInfo.first_name,
                        last_name: this.formUserAddInfo.last_name,
                        phone_number: this.formUserAddInfo.phone_number
                    }
                    console.log(param)
                    let loadingAddUser = this.$loading({
                        target: '.dv_addUser',
                        text: 'กำลังสร้างผู้ใช้งานสำหรับล๊อกอินเข้าสู่ระบบ...'
                    })
                    try {
                        let res = await fgApi.user.addUserFirebase(param)
                        console.log(res)
                        if (res.success) {
                            this.$message({
                                message: 'สร้างผู้ใช้งานเรียบร้อย.',
                                type: 'success'
                            })
                            this.customerID = res.userId
                            // this.stepActive++
                            this.nextStep()
                        } else {
                            if (res.message === `googleapi: Error 400: EMAIL_EXISTS, invalid`) {
                                this.$message({
                                    message: 'อีเมล์ซ้ำในระบบกรุณาตรวจสอบ',
                                    type: 'error'
                                })
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                })
                            }
                            // this.$message('Oops, Api is error !')
                        }
                    } catch (error) {
                        this.$message.error('Oops, Api is error !')
                    }
                    loadingAddUser.close()
                } else {
                    this.$message.error('กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน !')
                }
            })
        },
        async saveUserInfo (e) {
            this.$refs['formUserInfo'].validate(async (valid) => {
                if (valid) {
                    let param = {
                        user_id: this.customerID,
                        user_code: this.formUserInfo.user_code,
                        address: this.formUserInfo.address,
                        sub_district: this.formUserInfo.subDistrict,
                        district: this.formUserInfo.district,
                        province: this.formUserInfo.province,
                        zipcode: this.formUserInfo.zipcode
                    }

                    let paramCourierDefault = {
                        target_user_id: this.customerID,
                        courier_accounts_id: [ // defalut courier
                            43, // SCG
                            44, // FLASH
                            9, // Kerry
                            41, // Thai Post
                            42 // other

                        ],
                        auto_courier: [
                            {
                                courier_account_id: 43, // SCG
                                courier_id: 1,
                                day: 1
                            }, {
                                courier_account_id: 44, // FLASH
                                courier_id: 4,
                                day: 1
                            },
                            {
                                courier_account_id: 9, // Kerry
                                courier_id: 2,
                                day: -1
                            },
                            {
                                courier_account_id: 41, // Thai Post
                                courier_id: 6,
                                day: -1
                            }, {
                                courier_account_id: 42, // other
                                courier_id: 8,
                                day: -1
                            }
                        ]
                    }
                    let loading = this.$loading({
                        target: '.dv_addUser'
                    })

                    let res = await fgApi.user.updateUserInfo(param)
                    let resUpdateCourierAccount = await fgApi.courier.updateCourierAccount(paramCourierDefault)
                    console.log(resUpdateCourierAccount)
                    if (res.success && resUpdateCourierAccount.success) {
                        this.$message({
                            message: 'บันทึกข้อมูลเรียบร้อย.',
                            type: 'success'
                        })
                        // this.stepActive++
                    } else {
                        // this.$message.error('Oops, Api is error !')
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }

                    this.nextStep()
                    loading.close()
                } else {
                    this.$message.error('กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน !')
                }
            })
        },
        async saveFormShopInfo () {
            this.$refs['formShopInfo'].validate(async (valid) => {
                if (valid) {
                    let param = {
                        user_id: this.customerID,
                        name: this.formShopInfo.name,
                        phone_number: this.formShopInfo.phone_number,
                        goods_type: this.formShopInfo.goods_type,
                        line: this.formShopInfo.line,
                        email: this.formShopInfo.email,
                        facebook: this.formShopInfo.facebook,
                        instagram: this.formShopInfo.instagram,
                        address: this.formShopInfo.address,
                        sub_district: this.formShopInfo.subDistrict,
                        district: this.formShopInfo.district,
                        province: this.formShopInfo.province,
                        zipcode: this.formShopInfo.zipcode,
                        active_upload_slip: this.formShopInfo.active_upload_slip
                    }
                    console.log(param)

                    this.$message({
                        message: 'สร้างผู้ใช้งานเรียบร้อย.',
                        type: 'success'
                    })

                    let loadingAddUser = this.$loading({
                        target: '.dv_addUser',
                        text: 'กำลังสร้างผู้ใช้งานสำหรับล๊อกอินเข้าสู่ระบบ...'
                    })
                    try {
                        let res = await fgApi.shop.createShop(param)
                        console.log(res)
                        if (res.success) {
                            this.$message({
                                message: 'สร้างผู้ใช้งานเรียบร้อย.',
                                type: 'success'
                            })
                            this.customerID = res.userId
                            // this.stepActive++
                            this.nextStep()
                            this.dialogVisible = false
                            this.$emit('refreshTable')
                        } else {
                            this.$message('Oops, Api is error !')
                        }
                    } catch (error) {
                        this.$message.error('Oops, Api is error !')
                    }
                    loadingAddUser.close()
                } else {
                    this.$message.error('กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน !')
                }
            })
        }
    }
}
</script>

<style lang="scss">
.modalAddUser {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
</style>
